'use client';

import { c as _c } from "react/compiler-runtime";
import Confirmation from '../../common/Confirmation';
import { useNewPostContext } from './NewPostContext';
export const ModerationConfModal = () => {
  const $ = _c(8);
  const {
    moderationConfModalOpen,
    setModerationConfModalOpen,
    moderationRequiredFactiiis,
    forceSubmit
  } = useNewPostContext();
  if (!moderationConfModalOpen) {
    return null;
  }
  let t0;
  if ($[0] !== moderationRequiredFactiiis) {
    t0 = moderationRequiredFactiiis.join(", ");
    $[0] = moderationRequiredFactiiis;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = `This post contains factiiis (${t0}) that require moderation approval. These factiiis will be reviewed by the factiii's mods before it appears on your post. Do you want to proceed?`;
  let t2;
  if ($[2] !== setModerationConfModalOpen) {
    t2 = () => setModerationConfModalOpen(false);
    $[2] = setModerationConfModalOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== forceSubmit || $[5] !== t1 || $[6] !== t2) {
    t3 = <Confirmation title="Factiii Requires Moderation" message={t1} actionButtonText="Continue" cancelHandler={t2} confirmHandler={forceSubmit} />;
    $[4] = forceSubmit;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};